module.exports = __webpack_public_path__ + "static/media/icon_group_checkbox_select.eec4b1e6.svg";